import { render, staticRenderFns } from "./ReportOfficer.vue?vue&type=template&id=087ca910"
import script from "./ReportOfficer.vue?vue&type=script&lang=js"
export * from "./ReportOfficer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports